import React from "react";

function NavBar() {
  return (
    <div
      style={{
        display: "flex",
        height: "60px",
        alignItems: "center",
        backgroundColor: "rgb(223, 32, 32)",
        position:'sticky',
        top:"0px",
        zIndex:999
      }}
    >
      <div style={{ padding: "0 16px" }}>
        <img alt="" src="\assets\logo2.png" width={146} height={28} />
      </div>
    </div>
  );
}

export default NavBar;
